import type { ReactNode } from 'react'
import { HeroEventCard } from '../../components/HeroEventCard'
import { EventAttendanceMenu } from '../../components/EventAttendanceMenu'
import { Section } from '../../components/Section'
import type { EventInterestStatus } from '../../hooks/useUserEventInterests'
import type { FriendEventInterestBuckets } from '../../hooks/useFriendEventInterests'
import type { Event, UserProfile } from '../../types'

interface Props {
  event: Event
  status: EventInterestStatus
  buckets: FriendEventInterestBuckets | undefined
  profiles: Record<string, UserProfile>
  currentUserId: string | null
  today: string
  locale: string
  onOpen: () => void
  /** Omit for viewers who can't RSVP here. */
  onSetStatus?: (status: EventInterestStatus) => void
  menuFooter?: ReactNode
}


/** The group's soonest linked event, the crew's faces on it and a one-tap RSVP. */
export function NextTogetherCard({
  event, status, buckets, profiles, currentUserId, today, locale, onOpen, onSetStatus, menuFooter,
}: Props) {
  const going = buckets?.going ?? []
  const interested = buckets?.interested ?? []

  return (
    <Section testId="group-next-together">
      <HeroEventCard
        event={event}
        today={today}
        onClick={onOpen}
        facepile={{ userIds: [...going, ...interested], goingUserIds: new Set(going) }}
        profiles={profiles}
        currentUserId={currentUserId}
        locale={locale}
        action={
          onSetStatus ? (
            <EventAttendanceMenu
              variant="icon"
              status={status}
              onSetStatus={onSetStatus}
              footer={menuFooter}
              onDarkBackground={!!event.imageUrl}
            />
          ) : null
        }
      />
    </Section>
  )
}
